import React, { useState } from "react";
import { FiLock, FiEye, FiEyeOff, FiShield, FiMonitor, FiTrash2 } from "react-icons/fi";
import "./SecurityPrivacy.css";

const SecurityPrivacy = () => {
  const [twoFA, setTwoFA] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  const sessions = [
    { device: "Chrome on Mac", location: "Chennai, India", time: "Active now", current: true },
    { device: "Safari on iPhone", location: "Chennai, India", time: "2 hours ago", current: false },
    { device: "Firefox on Windows", location: "Bangalore, India", time: "Yesterday", current: false },
  ];

  const validate = () => {
    const e = {};
    if (!passwordForm.current) e.current = "Current password is required";
    if (!passwordForm.newPass || passwordForm.newPass.length < 8) e.newPass = "Min 8 characters";
    if (passwordForm.newPass !== passwordForm.confirm) e.confirm = "Passwords do not match";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChangePassword = () => {
    if (!validate()) return;
    setSuccessMsg("Password changed successfully!");
    setPasswordForm({ current: "", newPass: "", confirm: "" });
    setTimeout(() => { setSuccessMsg(""); setShowModal(false); }, 2000);
  };

  return (
    <div className="security-page">
      {/* Password Section */}
      <div className="security-card">
        <div className="security-card-header">
          <div className="security-icon-wrap">
            <FiLock size={20} />
          </div>
          <div>
            <h3>Password</h3>
            <p>Last changed 30 days ago</p>
          </div>
          <button className="sec-edit-btn" onClick={() => setShowModal(true)}>Change Password</button>
        </div>
      </div>

      {/* 2FA Section */}
      <div className="security-card">
        <div className="security-card-header">
          <div className="security-icon-wrap green">
            <FiShield size={20} />
          </div>
          <div>
            <h3>Two-Factor Authentication</h3>
            <p>{twoFA ? "Enabled — Your account is secured" : "Disabled — Add extra protection"}</p>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" checked={twoFA} onChange={() => setTwoFA(!twoFA)} />
            <span className="toggle-slider" />
          </label>
        </div>
        {twoFA && (
          <div className="twofa-info">
            <p>✓ Authentication app is configured</p>
          </div>
        )}
      </div>

      {/* Active Sessions */}
      <div className="security-card">
        <div className="sessions-header">
          <div className="sessions-title-row">
            <div className="security-icon-wrap purple">
              <FiMonitor size={20} />
            </div>
            <div>
              <h3>Active Sessions</h3>
              <p>{sessions.length} devices signed in</p>
            </div>
          </div>
        </div>
        <div className="sessions-list">
          {sessions.map((s, i) => (
            <div key={i} className="session-item">
              <div className="session-info">
                <span className="session-device">{s.device}</span>
                <span className="session-meta">{s.location} · {s.time}</span>
              </div>
              <div className="session-actions">
                {s.current ? (
                  <span className="badge-current">Current</span>
                ) : (
                  <button className="session-revoke">
                    <FiTrash2 size={14} /> Revoke
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Change Password Modal */}
      {showModal && (
        <div className="sec-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="sec-modal" onClick={e => e.stopPropagation()}>
            <div className="sec-modal-header">
              <h2>Change Password</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div className="sec-modal-body">
              {successMsg && <div className="success-banner">{successMsg}</div>}

              {[
                { label: "Current Password", key: "current", show: showCurrent, toggle: () => setShowCurrent(!showCurrent) },
                { label: "New Password", key: "newPass", show: showNew, toggle: () => setShowNew(!showNew) },
                { label: "Confirm New Password", key: "confirm", show: showConfirm, toggle: () => setShowConfirm(!showConfirm) },
              ].map(({ label, key, show, toggle }) => (
                <div className="sec-field" key={key}>
                  <label>{label}</label>
                  <div className="sec-input-wrap">
                    <input
                      type={show ? "text" : "password"}
                      value={passwordForm[key]}
                      onChange={e => setPasswordForm(prev => ({ ...prev, [key]: e.target.value }))}
                      placeholder={`Enter ${label.toLowerCase()}`}
                      className={errors[key] ? "input-error" : ""}
                    />
                    <button type="button" className="eye-btn" onClick={toggle}>
                      {show ? <FiEye /> : <FiEyeOff />}
                    </button>
                  </div>
                  {errors[key] && <span className="error-text">{errors[key]}</span>}
                </div>
              ))}

              <div className="sec-password-tips">
                <p>Password must:</p>
                <ul>
                  <li className={passwordForm.newPass.length >= 8 ? "met" : ""}>Be at least 8 characters</li>
                  <li className={/[A-Z]/.test(passwordForm.newPass) ? "met" : ""}>Have an uppercase letter</li>
                  <li className={/[0-9]/.test(passwordForm.newPass) ? "met" : ""}>Contain a number</li>
                </ul>
              </div>

              <div className="sec-modal-footer">
                <button className="btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn-save" onClick={handleChangePassword}>Update Password</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecurityPrivacy;
